module.exports = __webpack_public_path__ + "static/media/5.3f22dc35.JPG";